import { useEffect, useState } from "react";
import Header from "./Header";
import PaymentOptions from "./PaymentOptions";
import { useDispatch, useSelector } from "react-redux";
import { messageClear, user_registered } from "../store/reducers/authReducer";
import toast from "react-hot-toast";
import Contact from "./Contact";
import { IoClose } from "react-icons/io5";

import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
const Ticket = () => {
  const dispatch = useDispatch();
  const [selectedSize, setSelectedSize] = useState("");
  const [showImage, setShowImage] = useState(false);
  // Ticket price calculation
  const [showContactModal, setShowContactModal] = useState(true);
  const imageUrl = "https://i.ibb.co.com/NnsZYnfN/t-shirt.jpg";

  const sizes = ["M", "L", "XL", "XXL", "3XL"];

  const handleSizeClick = (size) => {
    setSelectedSize(size);
    setShowImage(true);

    setFormData((prev) => ({
      ...prev,
      tshirtSize: size,
    }));
  };
  useEffect(() => {
    setShowContactModal(true);
  }, []);
  const { successMessage, errorMessage } = useSelector((state) => state.auth);
  // State for form fields
  const [formData, setFormData] = useState({
    fullName: "",
    sscBatch: "",
    location: "",
    bloodGroup: "",
    section: "",
    phone: "",
    email: "",
    tshirtSize: "",
    paymentMethod: "",
    transactionId: "",
    spouseName: "",
    spouseType: "",
  });
  const basePrice = 1000;
  const spousePrice = formData.spouseType ? 700 : 0;
  const totalAmount = basePrice + spousePrice;

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Add validation or API call
    dispatch(user_registered(formData));
  };
  useEffect(() => {
    if (!successMessage && !errorMessage) return;

    toast.dismiss();

    if (successMessage) {
      toast.success(successMessage);

      // ✅ Clear form after success
      setFormData({
        fullName: "",
        sscBatch: "",
        location: "",
        bloodGroup: "",
        section: "",
        phone: "",
        email: "",
        tshirtSize: "",
        paymentMethod: "",
        transactionId: "",
        spouseName: "",
        spouseType: "",
      });
    }

    if (errorMessage) {
      toast.error(errorMessage);
    }

    // ✅ Always clear redux messages
    dispatch(messageClear());
  }, [successMessage, errorMessage]);
 useEffect(() => {
    setShowContactModal(true);
  }, []);
  return (
    <div>


        
      {/* Background Hero Section */}
      <div
        className="w-full min-h-screen bg-no-repeat bg-cover bg-center relative"
        style={{ backgroundImage: "url('https://i.ibb.co/fz4FG8WH/hero.png')" }}
      >
        {/* Gradient Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(0,8,50,0.85) 0%, rgba(0,40,120,0.88) 55%, rgba(0,10,60,0.9) 100%)",
          }}
        />

        {/* Header */}
        <Header />

        {/* Hero Content */}
        <div
          className="relative z-10 flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8 
 bg-gradient-to-br from-blue-950 via-blue-900 to-indigo-950"
        >
          <div
            className="w-full max-w-4xl rounded-2xl shadow-2xl p-6 sm:p-10 
 bg-white/10 backdrop-blur-xl border border-white/20 text-white"
          >
            <h2 className="text-3xl font-bold text-center mb-2 text-white">
              Buy Your Ticket
            </h2>
            <p className="text-center text-gray-200 mb-6">
              Secure your spot at the reunion
            </p>

            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* Full Name */}
              <div>
                <label className="block mb-2 font-medium">Full Name</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                  className="w-full rounded-md border px-4 py-3 outline-none 
focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition 
text-black placeholder-gray-500"
                  required
                />
              </div>

              {/* SSC Batch & Location */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block mb-2 font-medium">SSC Batch</label>
                  <select
                    name="sscBatch"
                    value={formData.sscBatch}
                    onChange={handleChange}
                    className="w-full rounded-md border px-4 py-3 outline-none 
focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition 
text-black placeholder-gray-500"
                    required
                  >
                    <option value="">Select your batch</option>
                    {Array.from({ length: 36 }, (_, i) => 1990 + i).map(
                      (year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ),
                    )}
                  </select>
                </div>

                <div>
                  <label className="block mb-2 font-medium">Location</label>
                  <input
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    placeholder="Enter your location"
                    className="w-full rounded-md border px-4 py-3 outline-none 
focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition 
text-black placeholder-gray-500"
                    required
                  />
                </div>
              </div>

              {/* Blood Group & Section */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block mb-2 font-medium">Blood Group</label>
                  <select
                    name="bloodGroup"
                    value={formData.bloodGroup}
                    onChange={handleChange}
                    className="w-full rounded-md border px-4 py-3 outline-none 
focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition 
text-black placeholder-gray-500"
                    required
                  >
                    <option value="">Select blood group</option>
                    {["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map(
                      (bg) => (
                        <option key={bg} value={bg}>
                          {bg}
                        </option>
                      ),
                    )}
                  </select>
                </div>

                <div>
                  <label className="block mb-2 font-medium">Section</label>
                  <select
                    name="section"
                    value={formData.section}
                    onChange={handleChange}
                    className="w-full rounded-md border px-4 py-3 outline-none 
focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition 
text-black placeholder-gray-500"
                    required
                  >
                    <option value="">Select section</option>
                    {["Science", "Commerce", "Arts"].map((section) => (
                      <option key={section} value={section}>
                        {section}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Phone & Email */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block mb-2 font-medium">Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="01XXXXXXXXX"
                    className="w-full rounded-md border px-4 py-3 outline-none 
focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition 
text-black placeholder-gray-500"
                    required
                  />
                </div>

                <div>
                  <label className="block mb-2 font-medium">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="example@email.com"
                    className="w-full rounded-md border px-4 py-3 outline-none 
focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition 
text-black placeholder-gray-500"
                    required
                  />
                </div>
              </div>

              <div className="">
                {/* T-Shirt Size */}
                <div className="w-full">
                  {/* Label */}
                  <label className="block mb-3 font-semibold text-white">
                    T-Shirt Size
                  </label>

                  {/* Size Options */}
                  <div className="grid grid-cols-3 gap-3">
                    {sizes.map((size) => (
                      <button
                        type="button"
                        key={size}
                        onClick={() => handleSizeClick(size)}
                        className={`rounded-lg border py-3 font-medium transition-all duration-200
              ${
                selectedSize === size
                  ? "bg-indigo-600 text-white border-indigo-600 shadow-md"
                  : "bg-white text-gray-800 hover:bg-indigo-50 border-gray-300"
              }
            `}
                      >
                        {size}
                      </button>
                    ))}
                  </div>

                  {/* Image Modal */}
                  {showImage && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
                      <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full p-4 animate-fadeIn">
                        {/* Close Button */}
                        <button
                          onClick={() => setShowImage(false)}
                          className="absolute top-3 right-3 text-gray-600 hover:text-red-500 text-2xl"
                        >
                          <IoClose />
                        </button>

                        {/* Image */}
                        <img
                          src={imageUrl}
                          alt="T-Shirt Size Guide"
                          className="w-full rounded-lg object-cover"
                        />

                        {/* Selected Size Info */}
                        <p className="mt-3 text-center font-medium text-gray-700">
                          Selected Size: {selectedSize}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block mb-2 font-medium">Spouse Type</label>

                  <select
                    name="spouseType"
                    value={formData.spouseType}
                    onChange={handleChange}
                    className="w-full rounded-md border px-4 py-3 outline-none
    focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition
    text-black"
                  >
                    <option value="">Select spouse</option>

                    <option value="husband">Husband</option>
                    <option value="wife">Wife</option>
                  </select>
                </div>
                {formData.spouseType && (
                  <div>
                    <label className="block mb-2 font-medium">
                      Spouse Name
                    </label>

                    <input
                      type="text"
                      name="spouseName"
                      value={formData.spouseName}
                      onChange={handleChange}
                      placeholder="Enter your spouse name"
                      className="w-full rounded-md border px-4 py-3 outline-none
      focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition
      text-black placeholder-gray-500"
                    />
                  </div>
                )}
              </div>
              {/* Ticket Pricing Info */}
              <div className="mt-6 p-5 rounded-xl bg-indigo-600/20 border border-indigo-400/30 backdrop-blur-md">
                <h3 className="text-xl font-bold mb-3 text-white">
                  Ticket Price Information
                </h3>

                <div className="space-y-2 text-white text-sm sm:text-base">
                  <div className="flex justify-between">
                    <span>Single Person Ticket</span>
                    <span className="font-semibold">৳1000</span>
                  </div>

                  {formData.spouseType && (
                    <div className="flex justify-between">
                      <span>Spouse Ticket</span>
                      <span className="font-semibold">৳700</span>
                    </div>
                  )}

                  <div className="border-t border-white/30 pt-2 flex justify-between text-lg font-bold">
                    <span>Total Amount</span>
                    <span className="text-yellow-300">৳{totalAmount}</span>
                  </div>
                </div>
              </div>

              {/* Payment Information */}
              <div className="mt-8">
                <h3 className="text-xl font-bold mb-4">Payment Information</h3>
                <p className="mb-6 text-[#fff] font-semibold rounded-md">
                  Please use the <span className="underline">Send Money</span>{" "}
                  option on bKash, Nagad to complete the payment.
                </p>

                <PaymentOptions />
              </div>

              {/* Select Payment Method */}
              <div className="mt-6">
                <label className="block mb-2 font-medium">
                  Select Payment Method*
                </label>
                <select
                  name="paymentMethod"
                  value={formData.paymentMethod}
                  onChange={handleChange}
                  className="w-full rounded-md border px-4 py-3 outline-none 
focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition 
text-black placeholder-gray-500"
                  required
                >
                  <option value="">Select method</option>
                  {["Bkash", "Nagad"].map((method) => (
                    <option key={method} value={method}>
                      {method}
                    </option>
                  ))}
                </select>
              </div>

              {/* Transaction ID */}
              <div>
                <label className="block mb-2 font-medium">
                  bKash/Nagad Transaction ID Or Number*
                </label>
                <input
                  type="text"
                  name="transactionId"
                  value={formData.transactionId}
                  onChange={handleChange}
                  placeholder="Enter your transaction ID/Number"
                  className="w-full rounded-md border px-4 py-3 outline-none 
focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition 
text-black placeholder-gray-500"
                  required
                />
                <span className="text-gray-200 text-sm">
                  Send payment to: 01XXX-XXXXXX (bKash/Nagad)
                </span>
              </div>

              {/* Submit Button */}
              <button
              disabled
                type="submit"
                className="w-full py-3 rounded-full text-white font-semibold
                           bg-gradient-to-r from-blue-500 to-indigo-600
                           hover:from-indigo-600 hover:to-blue-700
                           transition-all duration-300 shadow-xl"
              >
                Complete Registration
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* Support Section */}
      {/* ===== Support Section ===== */}
      <div className=" bg-gradient-to-br from-blue-950 via-blue-900 to-indigo-950 py-10">
        {/* Section Title */}
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold text-white">Need Assistance?</h3>
          <p className="text-gray-300 text-sm mt-2">
            Contact our team for ticket confirmation or technical help
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:px-8">
          {/* Ticket Confirmation Card */}
          <div className="relative group overflow-hidden rounded-3xl p-7 bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl transition duration-500 hover:-translate-y-2">
            {/* Glow Effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-green-400/20 to-emerald-500/20 opacity-0 group-hover:opacity-100 transition duration-500 blur-xl"></div>

            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-green-500/20 text-green-400 text-xl">
                  🎟
                </div>
                <h4 className="text-lg font-bold text-white">
                  Ticket Confirmation
                </h4>
              </div>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed">
                After completing payment, please contact us to verify and
                confirm your reunion ticket.
              </p>

              <div className="flex items-center justify-between">
                <span className="text-xl font-bold text-white tracking-wide">
                  01824926692
                </span>

                <div className="flex gap-5 text-2xl">
                  <a
                    href="tel:01824926692"
                    className="text-green-400 hover:text-white transition duration-300 hover:scale-110"
                  >
                    <FaPhoneAlt />
                  </a>

                  <a
                    href="https://wa.me/8801824926692"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-green-400 hover:text-white transition duration-300 hover:scale-110"
                  >
                    <FaWhatsapp />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Technical Support Card */}
          <div className="relative  group overflow-hidden rounded-3xl p-7 bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl transition duration-500 hover:-translate-y-2">
            {/* Glow Effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-red-400/20 to-pink-500/20 opacity-0 group-hover:opacity-100 transition duration-500 blur-xl"></div>

            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-500/20 text-red-400 text-xl">
                  🛠
                </div>
                <h4 className="text-lg font-bold text-white">
                  Technical Support
                </h4>
              </div>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed">
                Facing payment issues or registration problems? Our technical
                team is ready to assist you.
              </p>

              <div className="flex items-center justify-between">
                <span className="text-xl font-bold text-white tracking-wide">
                  01304409653
                </span>

                <div className="flex gap-5 text-2xl">
                  <a
                    href="tel:01304409653"
                    className="text-red-400 hover:text-white transition duration-300 hover:scale-110"
                  >
                    <FaPhoneAlt />
                  </a>

                  <a
                    href="https://wa.me/8801304409653"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-red-400 hover:text-white transition duration-300 hover:scale-110"
                  >
                    <FaWhatsapp />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Contact />
    </div>
  );
};

export default Ticket;
